<template>
    <v-flex :class="!recording.isActive ? 'shrink' : 'xs12'">
    <v-layout row wrap align-center>
        <v-slide-x-reverse-transition>
            <v-flex grow v-show="recording.isActive">
                <div class="recorder__label">
                    <input disabled
                           type="text"
                           class="bot-content__input__text"
                           placeholder="Recording...">
                </div>
            </v-flex>
        </v-slide-x-reverse-transition>
        <v-flex shrink v-if="recording.recorder && recording.recorder.isRecording()">
            <p class="recorder__timer">{{ recordingTime }}</p>
        </v-flex>
        <v-flex shrink>
            <v-btn v-show="!recording.isActive" icon dark color="red lighten-1" @click="startRecording()" class="mr-0">
                <v-icon>mdi-microphone</v-icon>
            </v-btn>
            <v-btn v-show="recording.isActive" icon dark color="grey lighten-3" @click="stopRecording()" class="mr-0">
                <v-icon color="red lighten-1">mdi-stop</v-icon>
            </v-btn>
        </v-flex>
    </v-layout>
    </v-flex>
</template>


<script>

    export default {
        name: "AudioInput",
        components: {

        },
        props: ["startRecordingCallback", "stopRecordingCallback", "onAudioReadyCallback"],
        data() {
            return {
                recording: {
                    isActive: false,
                }
            };
        },
        computed: {
            recordingTime: function () {
                return "0.00" // this.rec
            }
        },
        methods: {
            startRecording() {
                this.recording.isActive = true;
                this.startRecordingCallback();
                navigator.mediaDevices.getUserMedia({audio: true, video: false})
                    .then((stream) => {
                        this.rec = new MediaRecorder(stream);
                        this.audioChunks = [];
                        this.rec.start();
                        this.rec.ondataavailable = e => {
                            this.audioChunks.push(e.data);
                            console.log("chucks", this.audioChunks);
                            if (this.rec.state === "inactive") {
                                let blob = new Blob(this.audioChunks, {type: 'audio/ogg; codecs=opus'});
                                console.log("BLOB", blob);
                                this.onAudioReadyCallback(blob);
                                /* recordedAudio.src = URL.createObjectURL(blob);
                                recordedAudio.controls = true;
                                recordedAudio.autoplay = true;
                                audioDownload.href = recordedAudio.src;
                                audioDownload.download = 'mp3';
                                audioDownload.innerHTML = 'download';*/
                            }
                        }
                    })
                    .catch(function (e) {
                        console.log(e)
                    });
            },
            stopRecording() {
                console.log("AUDIO.RECORDER - StopRecording. Recorder: ", this.rec);
                this.recording.isActive = false;
                this.rec.stop();
                this.stopRecordingCallback();
            },

        }
    };
</script>

<style lang="scss" scoped>

    .recorder__label{
        max-width: 840px;
        align-items: center;
        margin: 0 auto;
        display: flex;
        position: relative;
        z-index: 1;
        caret-color: #9F48F7;
        flex: 4;
        padding: 5px 20px;
        //margin-right: 14px;
        height: 40px;
        background-color: #f2f5fa;
        border-radius: 25px;
        border: none;
        outline: none;
        font-size: 16px;
        &::placeholder {
            color: #BDBDBD
        }
    }

    .recorder__timer {
        align-items: center;
        margin: 0 auto;
        display: flex;
        position: relative;
        z-index: 1;
        caret-color: #9F48F7;
        flex: 4;
        padding: 5px 20px;
        //margin-right: 14px;
        height: 40px;
        background-color: transparent;
        border-radius: 25px;
        border: none;
        outline: none;
        font-size: 16px;
        &::placeholder {
            color: #BDBDBD
        }
    }
</style>
